import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PatientNavbarContext = createContext({
  patient: null,
  setPatientNavbar: () => {},
});

export function PatientNavbarProvider({ children }) {
  const location = useLocation();
  const [patient, setPatient] = useState(null);

  const setPatientNavbar = useCallback((next) => {
    setPatient(next || null);
  }, []);

  useEffect(() => {
    if (!/^\/admin\/medical-records\/[^/]+/.test(location.pathname)) {
      setPatient(null);
    }
  }, [location.pathname]);

  const value = useMemo(
    () => ({
      patient,
      setPatientNavbar,
    }),
    [patient, setPatientNavbar]
  );

  return (
    <PatientNavbarContext.Provider value={value}>{children}</PatientNavbarContext.Provider>
  );
}

export function usePatientNavbar() {
  return useContext(PatientNavbarContext);
}
